import { isShadowMode, shadowModeParams } from '@/config';

if (isShadowMode) {
  __webpack_public_path__ = `${shadowModeParams.host}/`;
}
